// used for incodox transaction type names
export enum TransferPricingTransactionTypeNames {
  ADMINISTRATION_SERVICES = 'Administration services',
  CUSTOMER_SUPPORT_SERVICES = 'Customer support services',
  HQ_SERVICES = 'HQ services',
  LOGISTIC_SERVICES = 'Logistic services',
  MANAGEMENT_SERVICES = 'Management services',
  MARKETING_SERVICES = 'Marketing services',
  SOFTWARE_RD_SERVICES = 'Software R&D services',
  CONSUMER_GOODS_WHOLESALE = 'Consumer goods wholesale',
  E_COMMERCE_RESALE = 'E-Commerce resale',
  HOME_FURNISHING_WHOLESALE = 'Home furnishing wholesale',
  INDUSTRIAL_PRODUCTS_WHOLESALE = 'Industrial products wholesale',
  SOFTWARE_RESALE = 'Software resale',
  MARKETING_AGENCY_SERVICES_RESALE = 'Marketing agency services resale',
  CONSTRUCTION_PRODUCTS_WHOLESALE = 'Construction products wholesale',
}

export enum TPTransactionDocumentsMetadataStatus {
  LOADING = 'loading',
  UPLOADED = 'uploaded',
  GENERATED = 'generated',
}
